import BaseDTO from '../base/BaseDTO';
import Dealership from '../dealership/Dealership';
import Sample from '../sample/Sample';
import Studio from '../studio/Studio';
import BatteryStatus from './BatteryStatus';
import PhysicalSampleState from './PhysicalSampleState';

export default class PhysicalSample extends BaseDTO {
    public macAddress: string | undefined;
    public state: PhysicalSampleState | undefined;
    public battery: BatteryStatus | undefined;
    public batteryVoltage: number | undefined;
    public firmwareVersion: string | undefined;
    public pcb: string | undefined;
    public inDrawer: boolean | undefined;
    public isLightOn: boolean | undefined;
    public lastDrawerEventReceivedAt: string | undefined;
    public ownerDealership: Dealership | undefined;
    public sample: Sample | undefined;
    public studio: Studio | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.macAddress = data['macAddress'] || undefined;
        this.state = data['state'] || undefined;
        this.battery = data['battery'] || undefined;
        this.batteryVoltage = data['batteryVoltage'] !== undefined
            ? data['batteryVoltage']
            : undefined;
        this.firmwareVersion = data['firmwareVersion'] || undefined;
        this.pcb = data['pcb'] || undefined;
        this.inDrawer = data['inDrawer'] !== undefined
            ? data['inDrawer']
            : undefined;
        this.isLightOn = data['isLightOn'] !== undefined
        ? data['isLightOn']
        : undefined;
        this.lastDrawerEventReceivedAt = data['lastDrawerEventReceivedAt']
            ? data['lastDrawerEventReceivedAt']
            : undefined;
        this.ownerDealership = data['ownerDealership']
            ? new Dealership(data['ownerDealership'])
            : undefined;
        this.sample = data['sample'] ? new Sample(data['sample']) : undefined;
        this.studio = data['studio'] ? new Studio(data['studio']) : undefined;
    }

    /**
     * Return just the path to the appropriate battery icon SVG.
     * - FULL, HIGH, MEDIUM → "/assets/images/battery_full.svg"
     * - LOW                 → "/assets/images/battery_low.svg"
     * - CRITICAL            → "/assets/images/battery_empty.svg"
     * - CHARGING            → "/assets/images/battery_full.svg"
     * - UNKNOWN (or undefined) → "/assets/images/battery_unknown.svg"
     */
    public getBatteryIconPath(): string {
        switch (this.battery) {
            case BatteryStatus.FULL:
            case BatteryStatus.HIGH:
            case BatteryStatus.MEDIUM:
                return '/assets/images/battery_full.svg';
            case BatteryStatus.LOW:
                return '/assets/images/battery_low.svg';
            case BatteryStatus.CRITICAL:
                return '/assets/images/battery_empty.svg';
            case BatteryStatus.CHARGING:
                return '/assets/images/battery_full.svg';
            case BatteryStatus.UNKNOWN:
            default:
                return '/assets/images/battery_unknown.svg';
        }
    }

    /**
     * If the battery status is CHARGING, return the text "Charging";
     * otherwise return null.
     */
    public getChargingText(): string | null {
        return this.battery === BatteryStatus.CHARGING ? 'Charging' : null;
    }

}
